/**
 * Apply to CUI Modal root (className). Popup does not forward className to Modal;
 * FixedContainer defaults to z-index 15, below the mobile side panel (250+).
 */
export const modalRootStackingCss = "m1hzbkka";

/**
 * Modals opened while the settings IA {@link CenteredOverlay} is visible. CUI
 * CenteredOverlay and Modal both default to zIndexLowestModal (15); later portals
 * can still lose pointer events when focus lock / scrim order conflicts, so stack
 * at the standard modal layer. Must stay below zIndexNotification (550) so global
 * success/error toasts remain visible while the modal is still open (e.g. invite flow).
 */
export const modalAboveOverlayStackingCss = "m1jf15cn";

require("./modal_stacking.wyw-in-js.css!=!../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./modal_stacking.js");